export const E164_REGEX = /^\+\d{10,15}$/